import { Component, ViewChild } from '@angular/core';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { TenderTeamMemberService } from '../../services/tender.team.member.service';
import { RouterService } from '../../services/routerService';
import { AddTenderTeamMemberDto } from '../../models/tender.team.members/tender.team.member.models';
import { ValidateComponent } from '../../components/common/validateComponent/validate.component';

@Component({
    selector: 'teamMember/add',
    template: require('./add.team.member.component.html'),
    styles: [require('./search.component.css')]
})
export class AddTeamMemberComponent extends ValidateComponent {
    request: AddTenderTeamMemberDto;
    domain: string;
    @BlockUI() blockUi: NgBlockUI;

    @ViewChild('validateForm', { static: false }) currentForm;

    constructor(loggedInUserService: LoggedInUserService,
        private readonly teamMemberService: TenderTeamMemberService,
        private readonly routerService: RouterService
    ) {
        super();

        this.request = new AddTenderTeamMemberDto();

        this.routerService.doNotAddCurrentPageToRouteStack();
        this.domain = loggedInUserService.getCurrentUser().email.split('@')[1];

        this.formErrors = {
            'firstName': '',
            'lastName': '',
            'email': ''
        };

        this.validationMessages = {
            'firstName': {
                'required': 'First Name is required.'
            },
            'lastName': {
                'required': 'Last Name is required.'
            },
            'email': {
                'required': 'Email address is required.',
                'pattern': 'Email address cannot contain the "@" symbol.'
            }
        }
    }

    onSubmit() {
        this.removeErrors();

        if (!this.showErrors(true)) {
            return;
        }

        this.blockUi.start();

        this.teamMemberService.add(this.request).subscribe(() => {
            this.back();

        },
            () => { this.blockUi.stop(); },
            () => { this.blockUi.stop(); });
    }

    back() {
        this.routerService.goBack('/teamMembers');
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/tender.team.members/add.team.member.component.ts